module.exports = __webpack_public_path__ + "static/profile-0099033003187c03da41dd62deaf636c.jpg";